import isEqual from "lodash/isEqual.js";

import {preferences} from "./data/model/index.js";

// dashboard_filter
export const DASHBOARD_FILTER_ALL = "all";
export const DASHBOARD_FILTER_MINE = "mine";
export const DASHBOARD_FILTER_SHAREDWITHME = "sharedWithMe";
export const DASHBOARD_FILTER_SHAREDBYME = "sharedByMe";
export const DASHBOARD_FILTER_ARCHIVED = "archived";
const ALL_DASHBOARD_FILTER = [
	DASHBOARD_FILTER_ALL,
	DASHBOARD_FILTER_MINE,
	DASHBOARD_FILTER_SHAREDWITHME,
	DASHBOARD_FILTER_SHAREDBYME,
	DASHBOARD_FILTER_ARCHIVED
];

// dashboard_view
export const DASHBOARD_VIEW_CARD = "card";
export const DASHBOARD_VIEW_LIST = "list";
const ALL_DASHBOARD_VIEW = [
	DASHBOARD_VIEW_CARD,
	DASHBOARD_VIEW_LIST
];

// extension_highlightColor
export const HIGHLIGHT_COLOR_YELLOW = "yellow";
export const HIGHLIGHT_COLOR_TOPIC_COLOR = "topicColor";
const ALL_HIGHLIGHT_COLOR = [
	HIGHLIGHT_COLOR_YELLOW,
	HIGHLIGHT_COLOR_TOPIC_COLOR
];

// defaults for all preferences
const defaults = {
	dashboard_filter:         DASHBOARD_FILTER_ALL,
	dashboard_view:           DASHBOARD_VIEW_CARD,
	displaySidebar:           true,
	extension_highlightColor: HIGHLIGHT_COLOR_TOPIC_COLOR,
	highContrastMode:         false,
	stickyTooltips:           true,
};

export default class Prefs {
	/**
	 * Pass the preferences object from the account object to constructor.
	 * @param {Object} prefsData
	 */
	constructor(prefsData?: preferences) {
		(this as any).p = {...defaults};
		if (prefsData)
			this.applyPrefs(prefsData);

		// save original here so we compare in isChanged().
		// this happens here as opposed to before the above assignment
		// so that we don't report the application of defaults
		// as changes to the user's preferences.
		(this as any).original = {
			...(this as any).p
		};
	}

	/**
	 * Returns preferences in a format suitable for storage in the account object.
	 */
	exportPrefs(): preferences {
		return {
			...(this as any).p
		};
	}

	/**
	 * Apply new prefs from outside the object.
	 */
	applyPrefs(newPrefs: preferences) {
		if (typeof newPrefs === "object") {
			for (const k in newPrefs)
				// @ts-expect-error TS(7006) FIXME
				this.applyPref(k, newPrefs[k]);
		} else
			console.warn("Expected prefs object");
	}

	/**
	 * This probably isn't useful outside of this class.
	 *
	 * @param {string} pref
	 * @param {string|boolean|number} user's pref value
	 * @return {string|boolean|number} actual resulting value
	 */
	// @ts-expect-error TS(7006) FIXME: Parameter 'pref' implicitly has an 'any' type.
	applyPref(pref, value) {
		try {
			// @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
			if (this[pref] !== undefined)
			// @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
				this[pref] = value;
			else
				(this as any).p[pref] = value;
		} catch (e) {
			console.warn("Error applying preference " + pref, e);
		}

		// @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
		if (this[pref] !== undefined)
		// @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
			return this[pref];
		else
			return (this as any).p[pref];
	}

	/**
	 * @return {boolean}
	 */
	isChanged() {
		return !isEqual((this as any).p, (this as any).original);
	}

	/**
	 * @return {string} See DASHBOARD_FILTER_* consts
	 */
	get dashboard_filter() {
		return (this as any).p.dashboard_filter;
	}

	/**
	 * @param {string} df
	 * @throws {Error}
	 */
	set dashboard_filter(df) {
		if (!ALL_DASHBOARD_FILTER.includes(df))
			throw new Error("Invalid dashboard_filter preference value: " + df);

		(this as any).p.dashboard_filter = df;
	}

	/**
	 * @return {string} See DASHBOARD_VIEW_* consts
	 */
	get dashboard_view() {
		return (this as any).p.dashboard_view;
	}

	/**
	 * @param {string} dv
	 * @throws {Error}
	 */
	set dashboard_view(dv) {
		if (!ALL_DASHBOARD_VIEW.includes(dv))
			throw new Error("Invalid dashboard_view preference value: " + dv);

		(this as any).p.dashboard_view = dv;
	}

	/**
	 * @return {boolean}
	 */
	get displaySidebar() {
		return (this as any).p.displaySidebar;
	}

	/**
	 * @param {boolean} ds
	 * @throws {Error}
	 */
	set displaySidebar(ds) {
		if (typeof ds !== "boolean")
			throw new Error("Invalid displaySidebar preference value: " + ds);

		(this as any).p.displaySidebar = ds;
	}

	/**
	 * @return {string} See HIGHLIGHT_COLOR_* consts
	 */
	get extension_highlightColor() {
		return (this as any).p.extension_highlightColor;
	}

	/**
	 * @param {string} c
	 * @throws {Error}
	 */
	set extension_highlightColor(c) {
		if (!ALL_HIGHLIGHT_COLOR.includes(c))
			throw new Error("Invalid extension_highlightColor preference value: " + c);

		(this as any).p.extension_highlightColor = c;
	}

	/**
	 * @return {boolean}
	 */
	get highContrastMode() {
		return (this as any).p.highContrastMode;
	}

	/**
	 * @param {boolean} hc
	 * @throws {Error}
	 */
	set highContrastMode(hc) {
		if (typeof hc !== "boolean")
			throw new Error("Invalid highContrastMode preference value: " + hc);

		(this as any).p.highContrastMode = hc;
	}

	/**
	 * @return {boolean|null} `null` if the user hasn't decided yet.
	 */
	get librarySearch() {
		return (this as any).p.librarySearch;
	}

	/**
	 * @param {boolean} ls
	 * @throws {Error}
	 */
	set librarySearch(ls) {
		if (typeof ls !== "boolean")
			throw new Error("Invalid librarySearch preference value: " + ls);

		(this as any).p.librarySearch = ls;
	}

	/**
	 * @return {boolean}
	 */
	get stickyTooltips() {
		return (this as any).p.stickyTooltips;
	}

	/**
	 * @param {boolean} st
	 * @throws {Error}
	 */
	set stickyTooltips(st) {
		if (typeof st !== "boolean")
			throw new Error("Invalid stickyTooltips preference value: " + st);

		(this as any).p.stickyTooltips = st;
	}
};
